import Phaser from "phaser";

export default class BonezButton extends Phaser.GameObjects.Container {
    constructor(scene, x, y, text, callback) {
        super(scene);
        this.scene = scene;
        this.x = x;
        this.y = y;
        this.text = text;
        this.callback = callback;

        this.createButton();
        this.scene.add.existing(this);
    }

    createButton() {
        this.button = this.scene.add.image(0, 0, "greenButton");
        this.button.setInteractive();
        this.button.setScale(2);

        this.buttonText = this.scene.add.text(0, 0, this.text, {
            font: '900 110px Truculenta',
            color: 'black',
        }).setOrigin(0.5, 0.5);
        Phaser.Display.Align.In.Center(this.buttonText, this.button);

        this.add(this.button);
        this.add(this.buttonText);

        //Glow effect
        const fx = this.button.postFX.addGlow(0x00ff00, 0, 0, false, 0.1, 16);
        this.scene.tweens.add({
            targets: fx,
            outerStrength: 3,
            yoyo: true,
            loop: -1,
            ease: 'sine.inout'
        });

        this.button.on("pointerdown", () => {
            this.scene.sound.play('click');
            this.callback();
        });
        
        //Hover effect
        this.button.on("pointerover", () => {
            this.button.setScale(2.1);
            this.buttonText.setScale(1.1);
            fx.color = 0xffffff;
        });
        this.button.on("pointerout", () => {
            this.button.setScale(2);
            this.buttonText.setScale(1);
            fx.color = 0x00ff00;
        });
    }

    show() {
        this.setVisible(true);
    }
}